import { render } from "./MultiDimensionTableTemplate.vue?vue&type=template&id=83bb7bde"
import script from "./MultiDimensionTableTemplate.vue?vue&type=script&lang=js"
export * from "./MultiDimensionTableTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/MultiDimensionTableTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83bb7bde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83bb7bde', __exports__)) {
    api.reload('83bb7bde', __exports__)
  }
  
  module.hot.accept("./MultiDimensionTableTemplate.vue?vue&type=template&id=83bb7bde", () => {
    api.rerender('83bb7bde', render)
  })

}


export default __exports__